export default __webpack_public_path__ + "static/media/payout.0c4c7f5e.svg";